import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { FormGroup, FormControl, Validators } from '@angular/forms';
// Services
import { MatDialogService } from '@my7n/ui';
import { TermsPayloadKeys } from "../../../interfaces/terms-payload-keys";
import { UserProfileFacadeService } from "../../../services/facades/user-profile-facade.service";

@Component({
    selector: 'newsletter-dialog',
    templateUrl: './newsletter-dialog.component.html',
    styleUrls: ['./newsletter-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class NewsletterDialogComponent implements OnInit {

  termsPayloadKeys = TermsPayloadKeys;

  newsletterForm: FormGroup<{
    [TermsPayloadKeys.Newsletter]: FormControl<boolean>;
  }>;

  public loading = false;

  constructor(
    public dialogRef: MatDialogRef<NewsletterDialogComponent>,
    private userProfileFacade: UserProfileFacadeService,
    public dialog: MatDialogService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit() {
    this.setupNewsletterForm();
  }

  private setupNewsletterForm() {
    this.newsletterForm = new FormGroup({
      [TermsPayloadKeys.Newsletter]: new FormControl<boolean>(false, [
        Validators.requiredTrue
      ])
    });
  }

  onSubmit() {
    if (!this.newsletterForm.valid) {
      console.warn('[NewsletterDialogComponent] Form is invalid', this.newsletterForm.valid, this.newsletterForm);
      this.newsletterForm.markAllAsTouched();
      this.cdr.markForCheck();
      return;
    }

    this.userProfileFacade.updateTermsNewsletterSubscription(true);
    this.dialogRef.close({ success: true });
  }

  closeDialog() {
    this.userProfileFacade.updateTermsNewsletterSubscription(false);
    this.dialogRef.close({ success: false });
  }
}

